import { useQuery } from '@apollo/client'

import { useAuth } from 'src/auth'
import FilterMenu from 'src/components/Overlays/FiltersMenu/FilterMenu'
import { useCurrentCompanyContext } from 'src/context/CurrentCompanyContext'
import { RoleType } from 'src/graphql/types/employees'
import { GET_VOICE_AGENTS } from 'src/graphql/voiceAgents.graphql'
import {
  activityLogConnectedStatusOptions,
  voiceAgentAnalysisResultOptions,
} from 'src/pages/CallAnalyticsPage/utils'
import { callStatusOptions } from 'src/pages/CallAnalyticsPage/utils'
import { callDirectionOptions } from 'src/pages/CallAnalyticsPage/utils'
import { callTypeOptions, updateUrl } from 'src/pages/CallAnalyticsPage/utils'

const Filters = ({
  callDirections,
  setCallDirections,
  callTypes,
  setCallTypes,
  callStatuses,
  setCallStatuses,
  selectedConnectedStatus,
  setSelectedConnectedStatus,
  selectedVoiceAgentAnalysisResults,
  setSelectedVoiceAgentAnalysisResults,
  selectedVoiceAgents,
  setSelectedVoiceAgents,
  selectedCallTags,
  setSelectedCallTags,
  voiceMailTemplateOptions,
  selectedEmployees,
  setSelectedEmployees,
  employeeOptions,
}: {
  callDirections: string[]
  setCallDirections: (value: string[]) => void
  callTypes: string[]
  setCallTypes: (value: string[]) => void
  callStatuses: string[]
  setCallStatuses: (value: string[]) => void
  selectedConnectedStatus: string[]
  setSelectedConnectedStatus: (value: string[]) => void
  selectedVoiceAgentAnalysisResults: string[]
  setSelectedVoiceAgentAnalysisResults: (value: string[]) => void
  selectedVoiceAgents: string[]
  setSelectedVoiceAgents: (value: string[]) => void
  selectedCallTags: string[]
  setSelectedCallTags: (value: string[]) => void
  voiceMailTemplateOptions: { label: string; value: string }[]
  selectedEmployees: string[]
  setSelectedEmployees: (value: string[]) => void
  employeeOptions: { label: string; value: string }[]
}) => {
  const company = useCurrentCompanyContext()
  const { currentUser } = useAuth()
  const isAdmin = currentUser?.roles?.includes(RoleType.ADMIN)
  const isVoiceAgentEnabled = company?.voiceAgentEnabled

  const { data: voiceAgentsData } = useQuery(GET_VOICE_AGENTS, {
    variables: {
      pageInfo: {
        limit: 20,
        offset: 0,
      },
    },
  })

  const voiceAgentOptions =
    voiceAgentsData?.voiceAgents?.items?.map((agent) => ({
      label: agent.name,
      value: agent.voiceAgentId,
    })) || []

  const callTagOptions = [
    { value: 'voe', label: 'VoE Call' },
    ...voiceMailTemplateOptions,
  ]

  return (
    <FilterMenu
      filters={[
        {
          title: 'Call Direction',
          selected: callDirections,
          onChange: (value) => {
            setCallDirections(value)
            updateUrl('callDirections', value.join(','))
          },
          options: callDirectionOptions,
        },
        {
          title: 'Call Type',
          selected: callTypes,
          onChange: (value) => {
            setCallTypes(value)
            updateUrl('callTypes', value.join(','))
          },
          options: callTypeOptions,
        },
        {
          title: 'Call Status',
          selected: callStatuses,
          onChange: (value) => {
            setCallStatuses(value)
            updateUrl('callStatuses', value.join(','))
          },
          options: callStatusOptions,
        },
        {
          title: 'Call Tags',
          selected: selectedCallTags,
          onChange: (value) => {
            setSelectedCallTags(value)
            updateUrl('callTags', value.join(','))
          },
          options: callTagOptions,
        },
        {
          title: 'Connected Status',
          selected: selectedConnectedStatus,
          onChange: (value) => {
            setSelectedConnectedStatus(value)
            updateUrl('connectedStatus', value.join(','))
          },
          options: activityLogConnectedStatusOptions,
        },
        ...(isVoiceAgentEnabled && isAdmin
          ? [
              {
                title: 'Analysis Results',
                selected: selectedVoiceAgentAnalysisResults,
                onChange: (value) => {
                  setSelectedVoiceAgentAnalysisResults(value)
                  updateUrl('analysisResults', value.join(','))
                },
                options: voiceAgentAnalysisResultOptions,
              },
            ]
          : []),
        ...(isVoiceAgentEnabled
          ? [
              {
                title: `Voice Agent`,
                selected: selectedVoiceAgents,
                onChange: (value) => {
                  setSelectedVoiceAgents(value)
                  updateUrl('voiceAgents', value.join(','))
                },
                options: voiceAgentOptions,
              },
            ]
          : []),
        {
          title: 'Employee',
          selected: selectedEmployees,
          onChange: (value) => {
            setSelectedEmployees(value)
            updateUrl('employees', value.join(','))
          },
          options: employeeOptions,
        },
      ]}
    />
  )
}

export default Filters
